// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";

// constants
import { apiRouter } from "@cloudspire/legacy-shared/src/constants/router";

// normalizers
import { contentParseShow } from "../normalizers/content";

export function contentContentPage({ query, preview, slug }) {
  return {
    key: generateUri({
      router: apiRouter,
      name: "Api.Content.Show",
      query: {
        ...query,
        searchType: "slug",
        preview,
      },
      parameters: {
        slug,
      },
    }),
    normalizer: contentParseShow,
  };
}

export function contentRoomListPage({
  preview,
  slug,
  useContent = true,
  query,
}) {
  return {
    key: useContent
      ? generateUri({
          router: apiRouter,
          name: "Api.Content.Show",
          query: {
            ...query,
            searchType: "slug",
            preview,
          },
          parameters: {
            slug,
          },
        })
      : null,
    normalizer: contentParseShow,
  };
}

export function contentCampaignPage({ query, preview, slug }) {
  return {
    key: generateUri({
      router: apiRouter,
      name: "Api.Content.Show",
      query: {
        ...query,
        searchType: "slug",
        preview,
      },
      parameters: {
        slug,
      },
    }),
    normalizer: contentParseShow,
  };
}
